import isEmpty from 'lodash-es/isEmpty';
import React from 'react';
import Spinner from '../Spinner/Spinner';
import {IStyleguideRoute} from '../../types/types';
import {MenuList} from './MenuList';
import './menu.scss';

/**
 * Свойства компонента.
 *
 * @prop {IStyleguideRoute[]} menu Пункты меню.
 */
interface IMenuProps {
    menu: IStyleguideRoute[];
}

/**
 * Компонент меню.
 */
const Menu: React.FC<IMenuProps> = ({menu}) => {
    return (
        <div className={`styleguide-menu ${isEmpty(menu) ? 'styleguide-menu-loading' : ''}`}>
            {isEmpty(menu) && <Spinner/>}
                
            <MenuList menu={menu}/>
        </div>
    );
};

export default Menu;
